module.exports = "/_next/static/images/CustomerDataFoundation@2x-61a53efd65f1bb6784ccb1521f87b63c.png";